import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
import shared from '../../../src/shared.js';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` This article only applies to users of the public npm registry.`}</p>
    </Note>
    <p>{`As an organization owner, you can view, download, and email receipts for the complete billing history of your organization.`}</p>
    <h2>{`Viewing receipts`}</h2>
    <ol>
      <li parentName="ol">
        <>{shared['user-login'].text}</>
        <>{shared['user-login'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['account-settings'].text}</>
        <>{shared['account-settings'].image}</>
      </li>
      <li parentName="ol">
        <p parentName="li">{`In the left sidebar, click the name of the organization whose billing receipts you want to view.`}</p>
        <>{shared['organization-selection'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['organization-billing-tab'].text}</>
        <>{shared['organization-billing-tab'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['billing-history'].text}</>
        <>{shared['billing-history'].image}</>
      </li>
      <li parentName="ol">
        <p parentName="li">{`To view a single receipt, find the row of the receipt you want to view, then, on the right side of the row, click the view icon.`}</p>
      </li>
      <li parentName="ol">
        <>{shared['billing-view'].text}</>
        <>{shared['billing-view'].image}</>
      </li>
    </ol>
    <h2>{`Downloading receipts`}</h2>
    <ol>
      <li parentName="ol">
        <>{shared['user-login'].text}</>
        <>{shared['user-login'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['account-settings'].text}</>
        <>{shared['account-settings'].image}</>
      </li>
      <li parentName="ol">
        <p parentName="li">{`In the left sidebar, click the name of the organization whose billing receipts you want to download.`}</p>
        <>{shared['organization-selection'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['organization-billing-tab'].text}</>
        <>{shared['organization-billing-tab'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['billing-history'].text}</>
        <>{shared['billing-history'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['billing-download'].text}</>
        <>{shared['billing-download'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['billing-download-checked'].text}</>
        <>{shared['billing-download-checked'].image}</>
      </li>
    </ol>
    <h2>{`Emailing receipts`}</h2>
    <ol>
      <li parentName="ol">
        <>{shared['user-login'].text}</>
        <>{shared['user-login'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['account-settings'].text}</>
        <>{shared['account-settings'].image}</>
      </li>
      <li parentName="ol">
        <p parentName="li">{`In the left sidebar, click the name of the organization whose billing receipts you want to email.`}</p>
        <>{shared['organization-selection'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['organization-billing-tab'].text}</>
        <>{shared['organization-billing-tab'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['billing-history'].text}</>
        <>{shared['billing-history'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['billing-email'].text}</>
        <>{shared['billing-email'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['billing-email-checked'].text}</>
        <>{shared['billing-email-checked'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['billing-email-receipt'].text}</>
        <>{shared['billing-email-receipt'].image}</>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<strong parentName="p">{`Send`}</strong>{`.`}</p>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      